import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "../AnonForms.module.css";

function DateTime({
  fields,
  utilities,
}) {

  const {
    createNoLabelInput
   } = utilities

  return (
    <PageWrapper legendInfo="Incident Date:" required="true">
      <div className={Styles.dateTimeContainer}>
        <div className={Styles.dateTimeInner}>
          {createNoLabelInput(fields.whereDate, "50%", `${Styles.anonInput} ${Styles.dateTime}`, "date")}
          {createNoLabelInput(fields.whereTime, "50%", `${Styles.anonInput} ${Styles.dateTime}`, "time")}
        </div>
      </div>
    </PageWrapper>
  );
}

export default DateTime;
